/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

// generic metrics
export const METRIC_TIME_LOAD_DATA_LEGACY = 'LoadDataLegacy';
export const METRIC_TIME_RENDER_TO_STRING = 'RenderToString';
export const METRIC_TIME_RENDER_SERVER = 'ServerRenderVnext';
export const METRIC_TIME_COMPLEX_TYPES = 'ComplexTypes';

// app cache metrics
export const METRIC_APP_CACHE_INSERT = 'AppCachePut';
